import { incotermsSendedService } from "@/_services";
export const incotermSended = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    file: {
      data: [],
      status: {},
    },
  },
  mutations: {
    getIncotermsRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getIncotermsSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getIncotermsError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
    getIncotermFileByIdRequest(state) {
      state.file.status = {
        downloading: true,
      };
    },
    getIncotermFileByIdError(state, error) {
      state.file.data = null;
      state.file.status = {
        error,
      };
    },
    getIncotermFileByIdSuccess(state, response) {
      state.file.data = response;
      state.file.status = {
        downloaded: true,
      };
    },
  },
  actions: {
    getIncoterms({ commit }, request) {
      commit("getIncotermsRequest");
      incotermsSendedService
        .getIncoterms(request.pagination, request.filters)
        .then((response) => {
          commit("getIncotermsSuccess", response);
        })
        .catch((error) => {
          commit("getIncotermsError", error);
        });
    },
    getIncotermFileById({ commit }, id) {
      commit("getIncotermFileByIdRequest");
      incotermsSendedService
        .getIncotermFileById(id)
        .then((res) => {
          commit("getIncotermFileByIdSuccess", res);
        })
        .catch((error) => {
          commit("getIncotermFileByIdError", error);
        });
    },
  },
};
